/**
 * The Budget Cap mark.
 *
 * Rebuilt as inline SVG rather than shipped as a bitmap: it stays crisp at every size,
 * costs about 700 bytes with no extra network request, and — the reason that matters
 * here — the shield interior is transparent, so the mark sits correctly on the light and
 * the dark theme without needing two files.
 *
 * The elements carry the meaning of the product: a ceiling line above, a group beneath
 * it, and the amount between them.
 */

interface LogoProps {
  /** Rendered size in pixels. The mark is square. */
  size?: number;
  className?: string;
}

export function Logo({ size = 28, className }: LogoProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      {/* Shield outline. Transparent inside so the page background shows through. */}
      <path
        d="M32 4.5 55.5 17v19.2c0 10.6-8.9 18.6-23.5 23.3C17.4 54.8 8.5 46.8 8.5 36.2V17L32 4.5Z"
        stroke="var(--logo-ink)"
        strokeWidth="5.5"
        strokeLinejoin="round"
      />
      {/* The cap: the ceiling the group agrees on. */}
      <rect x="17.5" y="15.5" width="29" height="5" rx="2.5" fill="var(--logo-accent)" />
      {/* The amount. */}
      <circle cx="32" cy="31" r="9.5" fill="var(--logo-accent)" />
      <path
        d="M32 25.2v11.6M35.2 27.6c-.8-.9-2-1.4-3.2-1.4-1.8 0-3.2 1-3.2 2.5s1.4 2.1 3.2 2.4c1.8.3 3.2.9 3.2 2.4s-1.4 2.5-3.2 2.5c-1.3 0-2.5-.5-3.2-1.4"
        stroke="var(--logo-on-accent)"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
      {/* The group. */}
      <circle cx="21" cy="45.5" r="4" fill="var(--logo-ink)" />
      <circle cx="43" cy="45.5" r="4" fill="var(--logo-ink)" />
      <path
        d="M13.5 55.5c1.3-3.3 4.2-5.4 7.5-5.4s6.2 2.1 7.5 5.4M35.5 55.5c1.3-3.3 4.2-5.4 7.5-5.4s6.2 2.1 7.5 5.4"
        fill="var(--logo-ink)"
      />
      <circle cx="32" cy="44" r="5.4" fill="var(--logo-ink)" />
      <path d="M23.2 57.5c1.6-4.3 5-7 8.8-7s7.2 2.7 8.8 7Z" fill="var(--logo-ink)" />
    </svg>
  );
}
